import { Badge } from "@mantine/core";
import type { ApartmentStatus } from "@/api/types";

type BadgeVariant = ApartmentStatus | "success" | "failed" | "running" | "partial_failure";

interface StatusBadgeProps {
  status: BadgeVariant;
}

const statusColors: Record<BadgeVariant, string> = {
  new: "green",
  stale: "gray",
  contacted: "yellow",
  applied: "blue",
  rejected: "red",
  ignored: "gray",
  removed: "dark",
  success: "green",
  failed: "red",
  running: "yellow",
  partial_failure: "orange",
};

const statusLabels: Record<BadgeVariant, string> = {
  new: "New",
  stale: "Stale",
  contacted: "Contacted",
  applied: "Applied",
  rejected: "Rejected",
  ignored: "Ignored",
  removed: "Removed",
  success: "Success",
  failed: "Failed",
  running: "Running",
  partial_failure: "Partial Failure",
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <Badge color={statusColors[status]} variant="filled" size="sm" tt="uppercase">
      {statusLabels[status]}
    </Badge>
  );
}

interface PriceBadgeProps {
  direction: "up" | "down";
}

export function PriceBadge({ direction }: PriceBadgeProps) {
  return (
    <Badge color={direction === "down" ? "green" : "red"} variant="filled" size="xs" ml="xs">
      {direction === "down" ? "Price Drop" : "Price Up"}
    </Badge>
  );
}
